import React from "react";
import { GenerateOutputContainer } from "../../../containers";

const GenerateOutput = (props) => {
  return <GenerateOutputContainer {...props} />;
};

export default GenerateOutput;
